import { csx } from '@vtex/admin-ui'

const styles = {
  content: csx({ gap: '$space-5' }),
  filledBox: csx({ gap: '$space-4', alignSelf: 'normal' }),
}

export default styles
